<template>
    <v-snackbar
            v-model="snackbar.visible"
            :timeout="snackbar.timeout"
            :multi-line="snackbar.multiline === true"
            right
            bottom
            :color="snackbar.color"
    >

        {{ snackbar.text }}

        <v-btn text dark @click="closeSnackbar">{{$t('Close')}}</v-btn>
    </v-snackbar>
</template>

<script>
  import { mapMutations } from 'vuex';
  import { SNACKBAR_SHOW, SNACKBAR_HIDE } from '../store/mutation-types';

  export default {
    name: 'AppSnackbar',
    computed: {
      snackbar() {
        return this.$store.state.snackbar;
      },
    },
    methods: {
      ...mapMutations([SNACKBAR_SHOW, SNACKBAR_HIDE]),
      closeSnackbar() {
        this[SNACKBAR_HIDE]();
      },
    },
  };
</script>

<style scoped>

</style>
